import React, { useState } from 'react';
import Translate from './Translate';
import Route from './Route';

import './App.css';

export default () => {
	return (
		<div className="page">
			<div className="ui container" style={{textAlign: 'center'}}>
				<Route path="/">
					<Translate />
				</Route>
			</div>
		</div>
	);
};